<template>
  <div class="outer">
    <div class="inner" :class="{'selected' : setting}">
      <i class="top left"></i>
      <i class="top right"></i>
      <div class="content option p-2 noselect" @click="$emit('update')">
        <img class="img-fluid" :src="icon" :title="description" :alt="description">
      </div>
      <i class="bottom right"></i>
      <i class="bottom left"></i>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Setting",
    props: {
      setting: {
        type: Boolean,
        required: true,
        default() {
          return false;
        }
      },
      description: {
        type: String,
        default() {
          return ""
        }
      },
      icon: {
        type: String,
        required: true,
        default() {
          return "/static/images/icons/options.png"
        }
      }
    }
  }
</script>

<style scoped>
  .inner.selected {
    background: #821F1C;
  }

  .outer {
    cursor: pointer;
  }

  .content {
    /*min-height: 60px;*/
  }
</style>



// WEBPACK FOOTER //
// src/components/tabs/settings/Setting.vue